import React, { FunctionComponent, useState } from 'react';
import withStyles from 'react-jss';
import { Modal, Icon } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import CreateCampaign from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/CreateCampaign/CreateCampaign';

import styles from './CreateCampaignModal.styles';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
};

const CreateCampaignModal: FunctionComponent<Props> = ({ classes }) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const closeModal = () => {
    setShowModal(false);
  };
  const handleClick = () => {
    setShowModal(!showModal);
  };

  return (
    <Modal
      size={'large'}
      trigger={
        <button className={classes.button} onClick={handleClick}>
          Create Campaign
        </button>
      }
      closeIcon
      open={showModal}
      onClose={closeModal}
      className={classes.modal}
    >
      <Modal.Header className={classes.modalHeader}>
        <Icon name="envelope open outline" />
        Create Campaign
      </Modal.Header>

      <Modal.Content>
        <Modal.Description>
          <CreateCampaign modalClose={closeModal} />
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

export default withStyles(styles)(CreateCampaignModal);
